(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  // from https://github.com/digitalbazaar/bedrock-angular-lazy-compile
  m.directive('vvLazyCompile', function($compile, $templateCache) {
    var linked = false;
    return {
      restrict: 'A',
      // run before just about anything else
      priority: 2000,
      terminal: true,
      compile: Compile,
      controller: ctrl,
    };

    function Compile(tElement, tAttrs) {
      var contents = tElement.contents();

      // TODO: automate ID generation and remove need to have user specify
      // use template cache for contents if requested
      if('vvLazyId' in tAttrs) {
        var cacheId = 'vv-lazy-compile-id:' + tAttrs.vvLazyId;
        var cached = $templateCache.get(cacheId);
        if (cached === undefined) {
          $templateCache.put(cacheId, contents);
        } else {
          // use cached contents (allow local contents to be GC'd)
          contents = cached;
        }
      }
      tElement.empty();

      return function(scope, element, attrs, ctrls, transcludeFn) {
        // bind-once to vv-lazy-compile=<expression>
        var removeWatch = scope.$watch(tAttrs.vvLazyCompile || function() { return linked }, function (value) {
          if (value) {
            // console.log('vvLazyCompile compile', tElement[0].tagName);
            removeWatch();
            compile();
          }
        });

        function compile() {
          // add contents back
          // TODO: avoid clone, if possible, when not using template cache
          element.append(contents.clone());

          if (!element.attr('ng-if') && !('noLazyIf' in tAttrs) && tAttrs.vvLazyCompile)
          element.attr('ng-if', tAttrs.vvLazyCompile);

          // avoid recursion during compile
          element.removeAttr('vv-lazy-compile');
          element.removeAttr('vv-lazy-id');

          // recompile element and link
          $compile(element)(scope, undefined, {
            parentBoundTranscludeFn: transcludeFn
          });
        }
      };
    }

    function ctrl() {
      linked = true;
    }
  });
})(window, window.angular);
